module.exports = __webpack_public_path__ + "static/media/Bill_befer_az_ajton.c4ff79a1.svg";